var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"px-0 py-2",attrs:{"items":_vm.breadcrumbs}}),_c('quantity-unit-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }